import { css } from 'styled-components';

import * as breakpoints from './breakpoints';

export const breakpointUntil = Object.entries(breakpoints).reduce((useBreakpoint, [name, size]) => {
  useBreakpoint[name] = (...styles) => css`
    @media (max-width: ${size - 1}px) {
      ${styles}
    }
  `;
  return useBreakpoint;
}, {});

export const breakpointFrom = Object.entries(breakpoints).reduce((useBreakpoint, [name, size]) => {
  useBreakpoint[name] = (...styles) => css`
    @media (min-width: ${size}px) {
      ${styles}
    }
  `;
  return useBreakpoint;
}, {});
